import LeadsList from "./LeadsList";

export default {
    list: LeadsList,
};
